/**
 * MSDF shader for batched chart text.
 *
 * Based on the cell-label tint shader, with one addition: an `aFWidthScale`
 * vertex attribute holding each glyph's font scale (fontSize / atlasSize,
 * including any max-width shrink). This lets glyphs of different sizes share a
 * single mesh: the mesh-level `uFWidth` uniform only carries the parts common
 * to the whole mesh (world scale * distanceFieldRange * resolution) and the
 * per-glyph scale is applied in the shader.
 */

export const msdfFrag = `
varying vec2 vTextureCoord;
varying vec4 vColors;
varying float vFWidthScale;

uniform sampler2D uSampler;

// world scale * distanceFieldRange * resolution (per-glyph font scale is in vFWidthScale)
uniform float uFWidth;

// the mesh's worldAlpha (e.g. the chart editor's translucent ghost preview)
uniform float uAlpha;

void main(void) {

  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.
  vec4 texColor = texture2D(uSampler, vTextureCoord);

  // MSDF
  float median = texColor.r + texColor.g + texColor.b -
                  min(texColor.r, min(texColor.g, texColor.b)) -
                  max(texColor.r, max(texColor.g, texColor.b));
  // SDF
  median = min(median, texColor.a);

  float screenPxDistance = uFWidth * vFWidthScale * (median - 0.5);
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);
  if (median < 0.01) {
    alpha = 0.0;
  } else if (median > 0.99) {
    alpha = 1.0;
  }

  // NPM Textures, NPM outputs
  gl_FragColor = vec4(vColors.rgb, vColors.a * alpha * uAlpha);
}`;

export const msdfVert = `
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColors;
attribute float aFWidthScale;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;
varying vec4 vColors;
varying float vFWidthScale;

void main(void) {
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
    vColors = aColors;
    vFWidthScale = aFWidthScale;
}`;
